
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-bc7f0ed4&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Register.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Register.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-bc7f0ed4!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Register.vue"),
  /* scopeId */
  "data-v-bc7f0ed4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/public/Register.vue
// module id = 95
// module chunks = 1